// Constants
const defaultAvatar: string = `https://${process.env.REACT_APP_CDN}/play-bingo/images/avatars/default.jpg`;
const noAvatarTypes: any[] = [
    undefined,
    null,
    '',
    'https://via.placeholder.com/150',
];

/**
 * @function setAvatar
 * Sets a blank avatar if no avatar is set
 *
 * @param {any} avatar The user object avatar property
 * @returns {string}
 */
function setAvatar(avatar: any): string {
    return noAvatarTypes.includes(avatar) ? defaultAvatar : avatar;
}

// Exports
export default setAvatar;
